import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgPipe } from '../../services/svg.pipe';

@Component({
  selector: 'app-svg',
  imports: [CommonModule, SvgPipe],
  templateUrl: './svg.component.html',
  styleUrl: './svg.component.scss'
})
export class SvgComponent {

  @Input() url: string = '';
  @Input() height: string | number | null = 28;
  @Input() width: string | number | null = null;
  @Input() class: string = '';

  protected cssSize(value: string | number | null | undefined): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    if (typeof value === 'number') {
      return `${value}px`;
    }
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    return /^\d+(\.\d+)?$/.test(trimmed) ? `${trimmed}px` : trimmed;
  }

}
